<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="物品编号">
              <el-input clearable v-model="queryParamForm.itemCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="IMEI号">
              <el-input clearable v-model="queryParamForm.imei"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="状态">
              <el-select
                clearable
                v-model="queryParamForm.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="订单编码">
              <el-input clearable v-model="queryParamForm.orderCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="回收商">
              <el-input
                clearable
                v-model="queryParamForm.recyclerName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions()"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList()"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="下单时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.orderTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.receiveTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="质检时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.qualityTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-button type="primary" @click="getServiceProviderListSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="batchChafferDialog"
              >批量议价</el-button
            >
            <el-button type="primary" @click="batchReturnGoodsDialog"
              >批量退货</el-button
            >
            <el-button type="primary" @click="batchSettleDialog"  v-if="userInfo.type!==3"
              >批量结算</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="itemCode" label="物品ID"> </el-table-column>
        <el-table-column prop="orderCode" label="订单ID"> </el-table-column>
        <el-table-column prop="categoryName" label="分类">
          <template slot-scope="scope">
            {{ scope.row.categoryName || "待验机" }}
          </template>
        </el-table-column>
        <el-table-column prop="brandName" label="品牌">
          <template slot-scope="scope">
            {{ scope.row.brandName || "待验机" }}
          </template>
        </el-table-column>
        <el-table-column prop="modelName" label="机型">
          <template slot-scope="scope">
            {{ scope.row.modelName || "待验机" }}
          </template>
        </el-table-column>
        <el-table-column prop="gradeName" label="等级"> </el-table-column>
        <el-table-column prop="recoveryAmount" label="回收价">
          <template slot-scope="scope">
            {{ scope.row.recoveryAmount > 0 ? scope.row.recoveryAmount : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="chafferType" label="议价方式">
          <template slot-scope="scope">
            <span v-if="scope.row.chafferType === 0">整单</span>
            <span v-else-if="scope.row.chafferType === 1">批量</span>
            <span v-else-if="scope.row.chafferType === 2">单台</span>
          </template>
        </el-table-column>
        <el-table-column prop="chaffererName" label="议价人"> </el-table-column>
        <el-table-column prop="recyclerName" label="回收商"> </el-table-column>
        <el-table-column prop="updateTime" label="更新时间"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">待质检</span>
            <span v-else-if="scope.row.status === 1">待确认</span>
            <span v-else-if="scope.row.status === 2">待结算</span>
            <span v-else-if="scope.row.status === 3">已结算</span>
            <span v-else-if="scope.row.status === 4">待议价</span>
            <span v-else-if="scope.row.status === 5">待退货</span>
            <span v-else-if="scope.row.status === 6">退货中</span>
            <span v-else-if="scope.row.status === 7">已退货</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="detail(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 4 || (scope.row.status === 2 && userInfo.type!=3) "
              @click="chafferDialog(scope.row)"
              >议价沟通</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 2 && userInfo.type!=3"
              @click="settleDialog(scope.row)"
              >结算付款</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 6"
              @click="returnGoodsDialog(scope.row)"
              >退货</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 议价沟通对话框 -->
    <el-dialog title="议价沟通" :visible.sync="isChafferFlag" width="700px">
      <div style="margin: 20px">
        <div>
          <el-form
            ref="chafferForm"
            :model="chafferForm"
            :rules="editorFormRules"
            label-width="140px"
          >
            <el-row>
              <el-col :span="12"
                ><el-form-item label="回收商">
                  {{ chafferForm.recyclerName }}
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="待议价台数">
                  {{ chafferForm.chafferNum }}台
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="待议价金额">
                  {{ chafferForm.chafferAmount }}元
                </el-form-item></el-col
              >
            </el-row>
            <el-form-item label="加价金额" prop="markUpAmount">
              <el-row>
                <el-col :span="12">
                  <el-input
                    clearable
                    v-model="chafferForm.markUpAmount"
                    @input="calcAmount($event)"
                  ></el-input
                ></el-col>
                <el-col :span="12">元</el-col>
              </el-row>
            </el-form-item>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="议价后机器总回收价">
                  {{ chafferForm.totalReceiveAmount }}元
                </el-form-item></el-col
              >
            </el-row>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="confirmMarkUpAmount"
            >确认加价</el-button
          >
          <el-button style="margin: 10px 20px" @click="chafferFail"
            >议价失败转退货</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 结算对话框 -->
    <el-dialog title="结算付款" :visible.sync="isSettleFlag" width="700px">
      <div style="margin: 20px">
        <div>
          <el-form
            ref="settleForm"
            :model="settleForm"
            :rules="editorFormRules"
            label-width="140px"
          >
            <el-row>
              <el-col :span="24"
                ><el-form-item label="回收商">
                  {{ settleForm.recyclerName }}
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24"
                ><el-form-item label="付款账号">
                  {{ settleForm.payAccount }}
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="待付款台数">
                  {{ settleForm.payNum }}台
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="待付款金额">
                  {{ settleForm.payAmount }}元
                </el-form-item></el-col
              >
            </el-row>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="confirmPay"
            >确认付款</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 结算对话框 -->
    <el-dialog title="退货发货" :visible.sync="isReturnGoodsFlag" width="700px">
      <div style="margin: 20px">
        <div>
          <el-form
            ref="returnGoodsForm"
            :model="returnGoodsForm"
            :rules="editorFormRules"
            label-width="140px"
          >
            <el-row>
              <el-col :span="12"
                ><el-form-item label="回收商">
                  {{ returnGoodsForm.recyclerName }}
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="退货联系人">
                  {{ returnGoodsForm.returnContacts }}
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="退货地址">
                  {{ returnGoodsForm.returnAddress }}
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="退货台数">
                  {{ returnGoodsForm.returnNum }}台
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="退货金额">
                  {{ returnGoodsForm.returnAmount }}元
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24"
                ><el-form-item label="退货信息">
                  <el-row>
                    <el-col :span="12">
                      <el-select
                        clearable
                        v-model="returnGoodsForm.maillingName"
                        placeholder="请选择"
                        filterable
                      >
                        <el-option
                          v-for="item in mailingOptions"
                          :key="item.name"
                          :label="item.name"
                          :value="item.name"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        clearable
                        v-model="returnGoodsForm.returnMailing"
                      ></el-input>
                    </el-col>
                  </el-row> </el-form-item
              ></el-col>
            </el-row>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="confirmReturnGoods"
            >确认退货</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 错误提示对话框 -->
    <el-dialog :visible.sync="isErrorDlg" width="400px">
      <div style="margin: 20px">
        <div>
          <div>
            <div style="margin-bottom: 10px">
              你选择的商品中存在如下情况，不可发起批量操作
            </div>
            <div style="margin-bottom: 5px">1、当前状态不符</div>
            <div>2、归属于多个回收商</div>
          </div>
        </div>
        <div style="text-align: center">
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >知道了</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 议价失败提示对话框 -->
    <el-dialog title="议价失败" :visible.sync="chafferFailDlg" width="400px">
      <div style="margin: 20px">
        <div>
          <div>
            <div style="margin-bottom: 10px">
              议价失败原因
            </div>
             <el-checkbox-group v-model="chafferRemark">
             <el-checkbox label="质检不满意"></el-checkbox>
             <el-checkbox label="价格不满意"></el-checkbox>
              </el-checkbox-group>
          </div>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="confirmReturnGoods"
            >确认退货</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
      <!-- 议价失败提示对话框 -->
    <el-dialog title="物品详情" :visible.sync="queryItemDlg" width="1000px" append-to-body>
      <div style="margin: 20px">
        <div>
          <item-detail ref="itemDetail"></item-detail>
        </div>
        <div style="text-align: right">
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ItemDetail from "../../components/itemDetail.vue";
export default {
  components: {ItemDetail},
  props: {},
  data() {
    return {
      queryItemDlg:false,
      itemCode:null,
      chafferRemark:[],
      // 查询数据
      queryParamForm: {
        brandId: null,
        modelId: null,
        categoryId: null,
        recyclerName: null,
        status: null,
        orderTime: null,
        qualityTime: null,
        receiveTime: null,
        imei: null,
        itemCode: null,
        orderCode: null,
      },
      // 订单状态选择框
      statusOptions: [
        {
          id: 0,
          name: "待质检",
        },
        {
          id: 1,
          name: "待确认",
        },
        {
          id: 2,
          name: "待结算",
        },
        {
          id: 3,
          name: "已结算",
        },
        {
          id: 4,
          name: "待议价",
        },
        {
          id: 5,
          name: "待退货",
        },
        {
          id: 6,
          name: "退货中",
        },
        {
          id: 7,
          name: "已退货",
        },
      ],
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      queryModelList: [],

      queryBrandOptions: [],

      queryCategoryOptions: [],

      // 新建编辑对话框数据
      userInfo: {},

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        code: null,
        name: null,
        contactPerson: null,
        contactNumber: null,
        systemQuotes: 0,
        defaults: 0,
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入回收商名称", trigger: "change" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "change" },
        ],
        contactNumber: [
          { required: true, message: "请输入联系电话", trigger: "change" },
        ],
      },

      dlgType: "change",
      multipleSelection: [],

      isChafferFlag: false,
      chafferForm: {
        recyclerName: 0,
        chafferNum: 0,
        chafferAmount: 0,
        markUpAmount: null,
        totalReceiveAmount: 0,
        chafferType:2
      },

      settleForm: {
        recyclerName: null,
        payAccount: null,
        payNum: 0,
        payAmount: 0,
      },

      returnGoodsForm: {
        recyclerName: null,
        returnContacts: null,
        returnAddress: null,
        returnNum: 0,
        returnAmount: 0,
        maillingName: null,
        returnMailing: null,
        chafferType:2
      },

      isSettleFlag: false,
      isReturnGoodsFlag: false,
      isErrorDlg: false,
      chafferFailDlg:false,

      mailingOptions: [],

      itemCodes: [],

      // 选择
      loading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    
    chafferFail(){
      this.isChafferFlag = false;
      this.chafferFailDlg = true;
      this.chafferRemark = []
    },
    
    confirmReturnGoods() {
      let self = this;
      let params = {};
      params.itemCodes = self.itemCodes;
      params.mailingName = this.returnGoodsForm.maillingName;
      params.returnMailing = this.returnGoodsForm.returnMailing;
      params.returnGoodsNum = this.returnGoodsForm.returnNum;
      params.returnGoodsAmount = this.returnGoodsForm.returnAmount;
      params.returnType = 0
      if(this.chafferFailDlg){
        params.returnType = 1
        params.remark = this.chafferRemark.join(",");
        params.chafferType = this.returnGoodsForm.chafferType
      }
      self.$api.confirmReturnGoods(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "退货操作成功",
            type: "success",
          });
          self.getServiceProviderListSearch();
          self.closeEditormodelDlg();
        }
      });
    },

    confirmPay() {
      let self = this;
      let params = {};
      params.itemCodes = self.itemCodes;
      params.settlementAccount = this.settleForm.payAccount;
      params.settlementNum = this.settleForm.payNum;
      params.settlementAmount = this.settleForm.payAmount;
      self.$api.confirmPay(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "付款操作成功",
            type: "success",
          });
          self.getServiceProviderListSearch();
          self.closeEditormodelDlg();
        }
      });
    },

    confirmMarkUpAmount() {
      
      let self = this;
      let params = {};
      params.itemCodes = self.itemCodes;
      params.markUpAmount = this.chafferForm.markUpAmount;
      params.totalReceiveAmount = this.chafferForm.totalReceiveAmount;
      params.chafferNum = this.chafferForm.chafferNum;
      params.chafferType = this.chafferForm.chafferType;
      self.$api.getItemChaffer(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "议价操作成功",
            type: "success",
          });
          self.getServiceProviderListSearch();
          self.closeEditormodelDlg();
        }
      });
    },

    calcAmount(e) {
      this.chafferForm.totalReceiveAmount =
        this.chafferForm.chafferAmount + Number(e);
    },
    // 议价
    batchChafferDialog() {
      let self = this;
      self.itemCodes = [];
      if (!this.multipleSelection.length > 0) {
        this.$message({
          message: "至少选择一个商品",
          type: "error",
        });
        return;
      }
      let recyclerNames = [];
      let recyclerName = null;
      let isSameStatus = false;
      let totalChafferAmount =0
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const e = this.multipleSelection[index];
        if (e.status != 4) {
          isSameStatus = true;
          break;
        }
        totalChafferAmount =  e.qualityAmount + totalChafferAmount;
        self.itemCodes.push(e.itemCode);
        recyclerNames.push(e.recyclerName);
        recyclerName = e.recyclerName;
      }
      let recyclerNameNum = new Set(recyclerNames);
      if (recyclerNameNum.size != 1 || isSameStatus) {
        this.isErrorDlg = true;
        return;
      }

      this.chafferForm.recyclerName = recyclerName;
      this.chafferForm.chafferNum = self.multipleSelection.length;
      this.chafferForm.chafferAmount = totalChafferAmount;
      this.chafferForm.markUpAmount = 0;
      this.chafferForm.totalReceiveAmount = totalChafferAmount;
      this.chafferForm.chafferType = 1
      this.isChafferFlag = true;
    },
    // 结算
    batchSettleDialog() {
      let self = this;
      self.itemCodes = [];
      if (!this.multipleSelection.length > 0) {
        this.$message({
          message: "至少选择一个商品",
          type: "error",
        });
        return;
      }
      let recyclerNames = [];
      let payAccounts = [];
      let isSameStatus = false;
      let settlementAmount =0
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const e = this.multipleSelection[index];
        if (e.status != 2) {
          isSameStatus = true;
          break;
        }
        settlementAmount =  e.recoveryAmount + settlementAmount;
        self.itemCodes.push(e.itemCode)
        recyclerNames.push(e.recyclerName)
        payAccounts.push(e.collectAccount)
      }
      let recyclerNameNum = new Set(recyclerNames);
       let payAccountNum = new Set(payAccounts);
      if (recyclerNameNum.size != 1 || payAccountNum.size!=1 || isSameStatus) {
        this.isErrorDlg = true;
        return;
      }
   
      let temp = self.multipleSelection[0]
      this.settleForm.payAccount =
        (temp.collectType == 0 ? "支付宝(" : "微信(") + temp.collectAccount + ")";
      this.settleForm.recyclerName = temp.recyclerName;
      this.settleForm.payNum = self.multipleSelection.length;
      this.settleForm.payAmount = settlementAmount;
      this.isSettleFlag = true;
    },
    // 退货
    batchReturnGoodsDialog() {
      let self = this;
      self.itemCodes = [];
      if (!this.multipleSelection.length > 0) {
        this.$message({
          message: "至少选择一个商品",
          type: "error",
        });
        return;
      }
      this.returnGoodsForm.chafferType = 1
      let recyclerids = [];
      let addressAccounts = [];
      let isSameStatus = false;
      let returnAmount =0
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const e = this.multipleSelection[index];
        if (e.status != 6) {
          isSameStatus = true;
          break;
        }
        returnAmount =  e.recoveryAmount + returnAmount;
        self.itemCodes.push(e.itemCode)
        recyclerids.push(e.recyclerId)
        addressAccounts.push(e.returnContacts+e.returnContactsPhone+e.returnAddress)
      }
      let recyclerNum = new Set(recyclerids);
      let addressNum = new Set(addressAccounts);
      if (recyclerNum.size != 1 || addressNum.size!=1 || isSameStatus) {
        this.isErrorDlg = true;
        return;
      }
   
      let temp = self.multipleSelection[0]

      this.returnGoodsForm.recyclerName = temp.recyclerName;
      this.returnGoodsForm.returnContacts =
        temp.returnContacts + "(" + temp.returnContactsPhone + ")";
      this.returnGoodsForm.returnAddress = temp.returnAddress;
      this.returnGoodsForm.returnNum = this.multipleSelection.length;
      this.returnGoodsForm.returnAmount = returnAmount;
      this.isReturnGoodsFlag = true;
    },
    // 议价
    chafferDialog(row) {
      let self = this;
      this.itemCodes=[]
      self.itemCodes.push(row.itemCode)
      this.chafferForm.recyclerName = row.recyclerName;
      this.chafferForm.chafferNum = 1;
      this.chafferForm.chafferType = 2;
      this.chafferForm.markUpAmount = row.markUpAmount;
      this.chafferForm.chafferAmount = row.qualityAmount;
      this.chafferForm.totalReceiveAmount = row.qualityAmount+row.markUpAmount;
      this.isChafferFlag = true;
    },
    // 结算
    settleDialog(row) {
      this.itemCodes=[]
      this.itemCodes.push(row.itemCode)
      this.settleForm.recyclerName = row.recyclerName;
      this.settleForm.payAccount =
        (row.collectType == 0 ? "支付宝(" : "微信(") + row.collectAccount||'' + ")";
      this.settleForm.payNum = 1;
      this.settleForm.payAmount = row.recoveryAmount;
      this.isSettleFlag = true;
    },
    // 退货
    returnGoodsDialog(row) {
      this.itemCodes=[]
      this.returnGoodsForm.chafferType = 2
      this.itemCodes.push(row.itemCode)
      this.returnGoodsForm.recyclerName = row.recyclerName;
      this.returnGoodsForm.returnContacts =
        row.returnContacts + "(" + row.returnContactsPhone + ")";
      this.returnGoodsForm.returnAddress = row.returnAddress;
      this.returnGoodsForm.returnNum = 1;
      this.returnGoodsForm.returnAmount = row.recoveryAmount;
      this.isReturnGoodsFlag = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    detail(row) {
      let self = this;
      self.itemCode = row.itemCode
      self.queryItemDlg = true
      this.$nextTick(()=>{
        self.$refs.itemDetail.init(self.itemCode)
      })
    },
    getCategroyOptions() {
      let self = this;
      this.$api
        .getTemplateValue({
          typeKey: "category",
        })
        .then((res) => {
          self.queryCategoryOptions = res.data || [];
        });
    },
    //改变分类，品牌和等级集合发生变化
    changeOtherOptions() {
      let self = this;
      self.$set(self.queryParamForm, "brandId", null);
      self.$set(self.queryParamForm, "modelId", null);
      self.$set(self, "queryModelList", []);
      self.getBrandOptions();
    },
    getBrandOptions() {
      let categoryId = this.queryParamForm.categoryId;
      if (categoryId === "") {
        this.$set(this, "queryBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryBrandOptions = res.data.records || [];
          });
      }
    },
    //快递公司
    getMailingOptions() {
      let self = this;
      self.$api
        .getClass({
          typeKey: "express_company",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.mailingOptions = res.data.records || [];
        });
    },
    getModelList() {
      let brandId = this.queryParamForm.brandId;
      this.$set(this.queryParamForm, "modelId", null);
      if (brandId === "") {
        this.$set(this, "queryModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryModelList = res.data.records || [];
          });
      }
    },
    deleteServiceProvider(id) {
      let self = this;
      self.$confirm("是否删除").then(() => {
        self.$api.deleteServiceProvider({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getServiceProviderListSearch();
          }
        });
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getServiceProviderListSearch();
    },

    // 获取表格数据
    getServiceProviderListSearch() {
      let self = this;
      self.$api
        .getConsignmentItemList({
          page: self.currentPage,
          size: self.pageSize,
          orderTimeStart:
            self.queryParamForm.orderTime instanceof Array &&
            self.queryParamForm.orderTime.length > 1
              ? self.queryParamForm.orderTime[0] + " 00:00:00"
              : null,
          orderTimeEnd:
            self.queryParamForm.orderTime instanceof Array &&
            self.queryParamForm.orderTime.length > 1
              ? self.queryParamForm.orderTime[1] + " 23:59:59"
              : null,
          receiveTimeStart:
            self.queryParamForm.receiveTime instanceof Array &&
            self.queryParamForm.receiveTime.length > 1
              ? self.queryParamForm.receiveTime[0] + " 00:00:00"
              : null,
          receiveTimeEnd:
            self.queryParamForm.receiveTime instanceof Array &&
            self.queryParamForm.receiveTime.length > 1
              ? self.queryParamForm.receiveTime[1] + " 23:59:59"
              : null,
          qualityTimeStart:
            self.queryParamForm.qualityTime instanceof Array &&
            self.queryParamForm.qualityTime.length > 1
              ? self.queryParamForm.qualityTime[0] + " 00:00:00"
              : null,
          qualityTimeEnd:
            self.queryParamForm.qualityTime instanceof Array &&
            self.queryParamForm.qualityTime.length > 1
              ? self.queryParamForm.qualityTime[1] + " 23:59:59"
              : null,
          orderCode: self.queryParamForm.orderCode || null,
          itemCode: self.queryParamForm.itemCode || null,
          recyclerName: self.queryParamForm.recyclerName || null,
          status: self.queryParamForm.status,
          imei: self.queryParamForm.imei || null,
          categoryId: self.queryParamForm.categoryId || null,
          brandId: self.queryParamForm.brandId || null,
          modelId: self.queryParamForm.modelId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      self.editServiceProviderForm = JSON.parse(JSON.stringify(row));
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isChafferFlag = false;
      this.isSettleFlag = false;
      this.isReturnGoodsFlag = false;
      this.isErrorDlg = false;
      this.chafferFailDlg = false;
      this.queryItemDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editServiceProviderForm"].validate((valid) => {
        if (valid) {
          let params = this.editServiceProviderForm;
          self.$api.updateServiceProvider(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getServiceProviderListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getServiceProviderListSearch();
    self.getCategroyOptions();
    self.getMailingOptions();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")).data;
  },
};
</script>
<style lang="less" scoped>
</style>
